import { SET_CURRENT_BOARD } from './types';

export default {
  [SET_CURRENT_BOARD](state, payload) {
    state.currentBoard = payload;
  }
};
